import { render, staticRenderFns } from "./MobileAlertRSCard.vue?vue&type=template&id=a2363414&scoped=true&"
import script from "./MobileAlertRSCard.vue?vue&type=script&lang=js&"
export * from "./MobileAlertRSCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileAlertRSCard.vue?vue&type=style&index=0&id=a2363414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2363414",
  null
  
)

export default component.exports